export const countHowManyPercent = (value: number, total: number) => {
  if (value !== 0 && total !== 0) {
    const answer = (value * 100) / total;
    return `${Number(answer).toFixed(0)} %`;
  }

  return "0 %";
};
